import React from "react";

export const ArgovLogo = ({ size = 34 }) => (
  <svg width={size} height={size} viewBox="0 0 34 34" className="argov-logo-spin" style={{ flexShrink: 0 }} aria-hidden="true">
    <defs>
      <filter id="glw" x="-50%" y="-50%" width="200%" height="200%">
        <feGaussianBlur stdDeviation="1.8" result="b" />
        <feMerge><feMergeNode in="b" /><feMergeNode in="SourceGraphic" /></feMerge>
      </filter>
    </defs>
    <circle cx="17" cy="17" r="16" fill="#0b1628" />
    <circle cx="17" cy="17" r="15" fill="none" stroke="#c97c2a" strokeWidth="1.5" />
    <line x1="17" y1="3" x2="17" y2="11" stroke="#4db8ff" strokeWidth="1.5" strokeLinecap="round" />
    <line x1="17" y1="23" x2="17" y2="31" stroke="#4db8ff" strokeWidth="1.5" strokeLinecap="round" />
    <line x1="3" y1="17" x2="11" y2="17" stroke="#4db8ff" strokeWidth="1.5" strokeLinecap="round" />
    <line x1="23" y1="17" x2="31" y2="17" stroke="#4db8ff" strokeWidth="1.5" strokeLinecap="round" />
    <circle cx="17" cy="17" r="4.5" fill="#4db8ff" opacity="0.2" filter="url(#glw)" />
    <circle cx="17" cy="17" r="2.2" fill="#4db8ff" />
    <circle cx="17" cy="17" r="1.1" fill="#ffffff" />
  </svg>
);
